export { AppDetails } from './app-details';
export { technicalDetailsI18n } from './tech-details/tech-details-from.i18';
export { documentationI18n } from './documentation/documentation-form.i18n';
export { descriptionI18n } from './description/description.i18n';
export { transactionLogI18n } from './transaction-log';
